export default __webpack_public_path__ + "static/DadsRecipe-15298acbe3b3c463178c05622d293220.woff";